<div class="tpiq-input-search">
  <input *ngIf="!isDisabled && !blurEntry" type="text" placeholder="{{placeHolder}}" class="input-field" [ngClass]="{'has-add-button': canAddNewEntry}"
         (keyup)="filterEntries($event)" (clickOutside)="resetSearchEntries()" (keydown.ArrowDown)="highlightNext($event)"
         (keydown.ArrowUp)="highlightPrevious($event)" (keydown.Enter)="selectEntry($event)" (keydown.tab)="resetSearchEntries()"
         [(ngModel)]="entry">
  <input *ngIf="isDisabled" type="text" placeholder="{{placeHolder}}" class="input-field" [ngClass]="{'has-add-button': canAddNewEntry}"
         (keyup)="filterEntries($event)" (clickOutside)="resetSearchEntries()" (keydown.ArrowDown)="highlightNext($event)"
         (keydown.ArrowUp)="highlightPrevious($event)" (keydown.Enter)="selectEntry($event)" (keydown.tab)="resetSearchEntries()"
         [(ngModel)]="entry" readonly>
  <input *ngIf="!isDisabled && blurEntry" type="text" placeholder="{{placeHolder}}" class="input-field" [ngClass]="{'has-add-button': canAddNewEntry}"
         (keyup)="filterEntries($event)" (clickOutside)="resetSearchEntries()" (keydown.ArrowDown)="highlightNext($event)"
         (keydown.ArrowUp)="highlightPrevious($event)" (keydown.Enter)="selectEntry($event)" (keydown.tab)="resetSearchEntries()"
         [(ngModel)]="entry" (blur)="setNewEntry($event)">

  <ul *ngIf="searchEntries.length>0" class="dropdown ui-menu" [ngClass]="{'has-button-ul': canAddNewEntry}">
    <li (click)="triggerOnSelectNone()" *ngIf="displayNone" class="ui-menu-item">
      --None--
    </li>
    <li *ngFor="let entry of searchEntries; let idx = index" (click)="triggerOnSelect($event, entry)" (mouseover)="highlightAtIndex(idx)"
        class="ui-menu-item" [ngClass]="{'highlight-option': highlightIndex == idx}">
      {{entry[searchKey]}}
    </li>
  </ul>

  <input class="add-button pointer" type="button" *ngIf="canAddNewEntry" (click)="addNewEntry($event)" value="Add" />
  <textarea  rows="2" placeholder="Description..." style="margin-top: 12px;max-width: 75%"  *ngIf="canAddDescription" [(ngModel)]="description"></textarea>
</div>
